import { useWorkflow } from '../providers/WorkflowProvider'

export const useIsLatestWorkflowVersion = (version: number) => {
  const { workflow } = useWorkflow()

  return workflow.versions[0].version === version
}

export default useIsLatestWorkflowVersion
